import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  headerWrapper: {
    backgroundColor: '#F7F7F7',
    padding: '0.5rem',
    color: '#F37320',
    fontWeight: 'bold'
  },
  headingContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    margin: '20px 5px',
  },
  containerData: {
    display: 'flex',
    justifyContent: 'space-around',
  },
  headingRight: {
    textAlign: 'right',
  },
  textRight: {
    textAlign: 'right'
  },
  cardWrapper: {
    margin: '20px 10px',
    padding: '10px 25px',
  },
  cardData: {
    fontSize: '12px',
    color: '#6F6F6F',
    paddingBottom: '5px'
  },
  cardValue: {
    fontSize: '20px'
  },
  refreshIcon: {
    verticalAlign: 'middle',
    cursor: 'pointer'
  },
  paginationWrapper: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: '#4A4A4A',
    fontSize: '14px',
    flexWrap: 'wrap'
  },
  paginationSelectWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  selectRoot: {
    width: '50px',
  },
  selectWrapper: {
    margin: '0 10px 0 20px'
  },
  clickable: {
    cursor: 'pointer'
  }
}))

export { useStyles }